import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const NumberHashIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
            <path
                d="M3.3335 7.5H16.6668"
                stroke="#21272E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.3335 12.5H16.6668"
                stroke="#21272E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.33317 2.5L6.6665 17.5"
                stroke="#21272E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3332 2.5L11.6665 17.5"
                stroke="#21272E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
